var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('AboutShop'),_c('hr'),_c('AboutProduct'),_c('hr'),_c('AboutDelivery'),_c('hr'),_c('AboutPayment')],1)}
var staticRenderFns = []

export { render, staticRenderFns }